module.exports = __webpack_public_path__ + "static/img/8.5caf930.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/8.png
// module id = 0qNr
// module chunks = 0